import { StateCreator } from "zustand";
import { logger } from "@/utils/logger";
import type { CreatePageStore } from "../createPageStore";

export interface TicketActions {
  setTicketId: (ticketId: string | null) => void;
  setVariationTicketId: (index: number, ticketId: string) => void;
  submitStart: () => void;
  submitSuccess: () => void;
  submitError: (error: string) => void;
  clearSubmissionError: () => void;
  setQuoteRequiresEmailConfirmation: (required: boolean) => void;
}

export const createTicketSlice: StateCreator<
  CreatePageStore,
  [["zustand/immer", never]],
  [],
  TicketActions
> = set => ({
  // Ticket actions
  setTicketId: (ticketId: string | null) =>
    set((state: CreatePageStore) => {
      state.ticket.id = ticketId;
    }),

  setVariationTicketId: (index: number, ticketId: string) =>
    set((state: CreatePageStore) => {
      state.ticket.variationTicketIds[index] = ticketId;
      // Set ticketId to the first variation's ticket ID if not already set
      if (!state.ticket.id && index === 0) {
        state.ticket.id = ticketId;
      }
      logger.info("SET_VARIATION_TICKET_ID action processed", {
        component: "CreatePageStore",
        metadata: {
          variationIndex: index,
          ticketId,
          updatedVariationTicketIds: state.ticket.variationTicketIds,
          totalVariationTicketIds: Object.keys(state.ticket.variationTicketIds)
            .length,
          alsoSetAsMainTicketId: !state.ticket.id && index === 0,
        },
      });
    }),

  submitStart: () =>
    set((state: CreatePageStore) => {
      state.ticket.designSubmitted = true;
      state.ticket.submissionError = null;
    }),

  submitSuccess: () =>
    set((state: CreatePageStore) => {
      state.ticket.designSubmitted = false;
      state.ticket.submissionError = null;
    }),

  submitError: (error: string) =>
    set((state: CreatePageStore) => {
      state.ticket.designSubmitted = false;
      state.ticket.submissionError = error;
    }),

  clearSubmissionError: () =>
    set((state: CreatePageStore) => {
      state.ticket.submissionError = null;
    }),

  setQuoteRequiresEmailConfirmation: (required: boolean) =>
    set((state: CreatePageStore) => {
      state.ticket.quoteRequiresEmailConfirmation = required;
    }),
});
